module.exports = __webpack_public_path__ + "static/img/Ellipse 110.9cb7225.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Ellipse 110.png
// module id = s47a
// module chunks = 1